import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "gold" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/hamb_menu_icon.svg",
    alt: "Movil Menu Icon"
}, null, -1 /* HOISTED */);
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h1", null, "VINCENT MEMORIAL"),
    /*#__PURE__*/ _createElementVNode("h1", null, "CATHOLIC HIGH SCHOOL")
], -1 /* HOISTED */);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/vmchs_shield.svg",
    alt: "Vicent Memorial Catholic High School Shield"
}, null, -1 /* HOISTED */);
const _hoisted_6 = { class: "partners" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/donate_icon.svg",
    alt: "Donate Icon"
}, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("a", {
    href: "https://www.gradelink.com/",
    rel: "noreferrer",
    target: "_blank"
}, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: "/images/grade_icon.svg",
        alt: "Gradelink Icon"
    })
], -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("a", {
    href: "http://www.usasjs.org/",
    rel: "licence",
    target: "_blank"
}, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: "/images/sjs_icon.svg",
        alt: "Sister Servants SJS Org Icon"
    })
], -1 /* HOISTED */);
const _hoisted_10 = {
    ref: "menuEle",
    id: "navMenu"
};
const _hoisted_11 = { class: "center" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/vmchs_shield.svg",
    alt: "Vicent Memorial Catholic High School Shield"
}, null, -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/close_icon.svg",
    alt: "Close Icon"
}, null, -1 /* HOISTED */);
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = /*#__PURE__*/ _createTextVNode("ABOUT");
const _hoisted_16 = /*#__PURE__*/ _createTextVNode("ADMISSION");
const _hoisted_17 = /*#__PURE__*/ _createTextVNode("ACADEMICS");
const _hoisted_18 = /*#__PURE__*/ _createTextVNode("FAITH");
const _hoisted_19 = /*#__PURE__*/ _createTextVNode("ATHLETICS");
const _hoisted_20 = /*#__PURE__*/ _createTextVNode("GALLERY");
const _hoisted_21 = /*#__PURE__*/ _createTextVNode("NEWS");
const _hoisted_22 = /*#__PURE__*/ _createTextVNode("CONTACT US");
const _hoisted_23 = { class: "partners" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/donate_icon.svg",
    alt: "Donate Icon"
}, null, -1 /* HOISTED */);
const _hoisted_25 = /*#__PURE__*/ _createStaticVNode("<a href=\"https://www.gradelink.com/\" rel=\"noreferrer\" target=\"_blank\"><img src=\"/images/grade_icon.svg\" alt=\"Gradelink Icon\"></a><a href=\"http://www.sisterservantssjs.org/\" rel=\"licence\" target=\"_blank\"><img src=\"/images/sjs_icon.svg\" alt=\"Sister Servants SJS Org Icon\"></a><a href=\"https://varsitymade.co/pages/vincent-memorial-home-page?_pos=2&amp;_sid=364a5cdc3&amp;_ss=r\" target=\"_blank\" rel=\"noopener noreferrer\"><img src=\"/images/shirts.png\" alt=\"Varsity Made Shirts\"></a>", 3);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("header", null, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "hamb-menu-btn",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
                }, _hoisted_3),
                _hoisted_4,
                _createElementVNode("figure", null, [
                    _createVNode(_component_router_link, { to: { name: 'Index' } }, {
                        default: _withCtx(() => [
                            _hoisted_5
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, { to: { name: 'Donate' } }, {
                    default: _withCtx(() => [
                        _hoisted_7
                    ]),
                    _: 1 /* STABLE */
                }),
                _hoisted_8,
                _hoisted_9
            ])
        ]),
        _createElementVNode("nav", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("figure", null, [
                    _createVNode(_component_router_link, { to: { name: 'Index' } }, {
                        default: _withCtx(() => [
                            _hoisted_12
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createElementVNode("div", {
                        class: "close-btn",
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
                    }, _hoisted_14)
                ]),
                _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: { name: 'About' } }, {
                            default: _withCtx(() => [
                                _hoisted_15
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: { name: 'Admission' } }, {
                            default: _withCtx(() => [
                                _hoisted_16
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: { name: 'Academics' } }, {
                            default: _withCtx(() => [
                                _hoisted_17
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: { name: 'Faith' } }, {
                            default: _withCtx(() => [
                                _hoisted_18
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: { name: 'Athletics', params: { subpage: 'boys' } } }, {
                            default: _withCtx(() => [
                                _hoisted_19
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: { name: 'PhotoGallery' } }, {
                            default: _withCtx(() => [
                                _hoisted_20
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: { name: 'News' } }, {
                            default: _withCtx(() => [
                                _hoisted_21
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: { name: 'Contact' } }, {
                            default: _withCtx(() => [
                                _hoisted_22
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_router_link, { to: { name: 'Donate' } }, {
                        default: _withCtx(() => [
                            _hoisted_24
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _hoisted_25
                ])
            ])
        ], 512 /* NEED_PATCH */)
    ], 64 /* STABLE_FRAGMENT */));
}
